var React = require('react');

function GoCircle (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:#fff;stroke:#1d2340;}.b{fill:#1d2340;}.c{stroke:none;}.d{fill:none;}")),React.createElement("g",{"transform":"translate(-434.642)","key":1},[React.createElement("g",{"className":"a","transform":"translate(434.642 24) rotate(-90)","key":0},[React.createElement("circle",{"className":"c","cx":"12","cy":"12","r":"12","key":0}),React.createElement("circle",{"className":"d","cx":"12","cy":"12","r":"11.5","key":1})]),React.createElement("path",{"className":"b","d":"M4.832,0,9.664,7.823H0Z","transform":"translate(451.625 6.931) rotate(90)","key":1})])]);
}

GoCircle.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = GoCircle;

GoCircle.default = GoCircle;
